// extracted by mini-css-extract-plugin
module.exports = {"upload-btn":"upload-btn-TeMKyUZoeL","uploadBtn":"upload-btn-TeMKyUZoeL","alert":"alert-e9SqIkH3dB"};